import {http} from '@/helpers/http-helper';

class Headquarters {
    constructor(
        uuid,
        code,
        name,
        nif,
        address,
        town,
        postalCode,
        province,
        community,
        phone1,
        phone2,
        email,
        payer,
        payerNif,
        bankAccount,
        suffix,
        ine,
        creditorIdentifier,
        mandateSignDate,
        president,
        position,
        header,
        footer,
        logoPath,
        signaturePath,
        departments,
        agreements,
        representative,
        representativeSignaturePath
    ) {
        this.uuid = uuid;
        this.code = code;
        this.name = name;
        this.nif = nif;
        this.address = address;
        this.town = town;
        this.postalCode = postalCode;
        this.province = province;
        this.community = community;
        this.phone1 = phone1;
        this.phone2 = phone2;
        this.email = email;
        this.payer = payer;
        this.payerNif = payerNif;
        this.bankAccount = bankAccount;
        this.suffix = suffix;
        this.ine = ine;
        this.creditorIdentifier = creditorIdentifier;
        this.mandateSignDate = mandateSignDate;
        this.president = president;
        this.position = position;
        this.header = header;
        this.footer = footer;
        this.logoPath = logoPath;
        this.signaturePath = signaturePath;
        this.departments = departments;
        this.agreements = agreements;
        this.representative = representative;
        this.representativeSignaturePath = representativeSignaturePath;
    }
}

export const getHeadquarters = () => {
    return new Promise((resolve, reject) => {
        const url = 'headquarters';
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    let headquarters = [];
                    response.data.forEach((headquarter) => {
                        headquarters.push(new Headquarters(
                            headquarter.uuid,
                            headquarter.code,
                            headquarter.name,
                            headquarter.nif,
                            headquarter.address,
                            headquarter.town,
                            headquarter.postalCode,
                            headquarter.province,
                            headquarter.community,
                            headquarter.phone1,
                            headquarter.phone2,
                            headquarter.email,
                            headquarter.payer,
                            headquarter.payerNif,
                            headquarter.bankAccount,
                            headquarter.suffix,
                            headquarter.ine,
                            headquarter.creditorIdentifier,
                            new Date(headquarter.mandateSignDate),
                            headquarter.president,
                            headquarter.position,
                            headquarter.header,
                            headquarter.footer,
                            headquarter.logoPath,
                            headquarter.signaturePath,
                            headquarter.departments,
                            headquarter.agreements,
                            headquarter.representative,
                            headquarter.representativeSignaturePath
                        ));
                    });

                    resolve(headquarters);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getExampleCertificatePreview = (headquartersId, certificateType) => {
    return new Promise((resolve, reject) => {
        const url = 'headquarters/' + headquartersId + '/example-certificate/preview';
        http.get(
            url,
            {
                certificateType: certificateType
            },
            'blob'
        )
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getExampleFeeCertificatePreview = (headquartersId, certificateType) => {
    return new Promise((resolve, reject) => {
        const url = 'headquarters/' + headquartersId + '/example-fee-certificate/preview';
        http.get(
            url,
            {
                certificateType: certificateType
            },
            'blob'
        )
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};
